// initial state
const state = () => ({
    tutorials: [],
});

// getters
const getters = {
    getTutorialsState(state) {
        return state;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setTutorialsState(state, payload) {
        state.tutorials = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
